<script>
    import { CommonMixin } from '@/mixins/commonMethods';
    import {mapMutations} from "vuex";
    export default {
        name: "Product Image Preview",
        mixins: [CommonMixin],
        props: {
            images: {
                required: true
            },
            headerImage: {
                required: true
            },
            actProduct: {},
            isShowBtn: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            changeImage(e) {
                const left = e.target.getBoundingClientRect().left
                const right = e.target.getBoundingClientRect().right
                const width = right-left
                const images = this.$props.images
                const partSize = width/images?.length
                const currentIndex = Math.floor((e.clientX-left)/partSize)

                if (images) {
                    this.$refs['product-image'].style.background = "url(" + this.setImageThumbURL(images[currentIndex]) + ")"
                }
                let index = 0

                if (!this.$refs["images-bar"]) return
                for (let [ind, part] of this.$refs["images-bar"].childNodes.entries()) {
                    if (part.style) {
                        if (index === currentIndex) {
                            part.style.background = "#DC33DF"
                        } else {
                            part.style.background = "rgba(233, 233, 233, 0.4)"
                        }
                        index++
                    }
                }
            },
            unsetImage(e) {
                this.$refs['product-image'].style.background = 'url(' + this.headerImage + ')'
            },

            ...mapMutations(['SET_BUY_NOW']),
            setBuyNow() {
                this.SET_BUY_NOW({...this.actProduct});
                this.$router.push({path: '/checkout'})
            }
        },
        mounted() {
            this.serverURL = process.env.VUE_APP_SERVER_URL.replace(/\\/g, '/');
        }
    }
</script>

<template>
    <div :ref="'product-image'" class="product-image" :style="'background: url(' + headerImage + ')'" ref="product-image" @mousemove=changeImage @mouseout=unsetImage>
        <div v-if="!isMobile && isShowBtn" class="buy-now-btn" @click="setBuyNow" @click.stop="handleInternalClick">Купить сейчас</div>
        <div v-if="!isMobile" class="images-bar" ref="images-bar">
            <div v-for="image of images" class="switch-image">
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;
    .product-image {
        cursor: pointer;
        aspect-ratio: 1 / 1; /* Соотношение сторон 1:1 */
        width: 100%;
        height: auto;
        background-size: cover !important;
        background-position: center !important;
        border: 2px solid $gray;
        margin-bottom: 20px;
        box-sizing: border-box;

        padding: 8px 10px;

        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    }

    .product-image > * {
        width: 100%;
        cursor: pointer;
    }

    .buy-now-btn {
        opacity: 0;

    }

    .product-image > .buy-now-btn {
        display: flex;
        justify-content: center;
        align-items: center;

        transition: $transition;

        height: 11%;
        background: $light-gray;
        font-size: 10px;
        text-transform: uppercase;
        font-weight: 500;
        border: 1px solid $gray;
        margin-bottom: 3px;

        box-sizing: border-box;
    }

    .images-bar {
        display: flex;
        flex-direction: row;
        transition: $transition;
    }

    .switch-image:first-child {
        background: $purple;
    }

    .switch-image {
        height: 2px;
        background: rgba(233, 233, 233, 0.4);
        width: 100%;
    }

    .product-image > * {
        opacity: 0;
    }

    .product-image:hover > * {
        opacity: 1;
    }
</style>
